<template>

<!--  :value="(item.ghyt === '10' ? '住宅' : (item.ghyt === '123'?'商业':''))-->
  <div class="houseList">
    <bv-top></bv-top>
<!--    <van-notice-bar left-icon="volume-o"-->
<!--                    text="尊敬的用户，本页面只显示房交会期间签订的商品房购房合同，若未查询到您名下符合条件的房屋，请到主管部门咨询办理。"-->
<!--    />-->
    <van-card v-for="(item, index) in houseList" :key="index">
      <div class="title" slot="title">
        <div class="titleContent">合同编号：{{item.htbh}}</div>
        <van-tag type="primary" mark align="float:right" v-if="item.ywzt === '0'">已办证待申请</van-tag>
        <van-tag type="warning" mark align="float:right" v-if="item.ywzt === 'X'">未办证无法申请</van-tag>
        <van-tag type="success" mark align="float:right" v-if="item.ywzt === '1'">已申请</van-tag>
        <van-tag type="primary" mark align="float:right" v-if="item.ywzt === '4'">补贴完成</van-tag>
      </div>
      <div slot="desc">
        <van-cell-group>
          <van-cell title="行政区代码" :value="item.xzqh" />
          <van-cell title="房屋坐落" :value="item.fwzl" />
          <van-cell title="房屋性质" >
              {{item | ghytFilter}}
          </van-cell>
          <van-cell title="建筑面积" :value="item.htmj+'㎡'" />
          <van-cell title="合同金额" :value="'¥'+item.htje" />
          <van-cell title="合同备案时间" :value="item.htbasj" />
          <van-cell title="签约方式" :value="item.cxfs === '0' ? '本人签约' : '监护人签约'" />
          <van-cell title="驳回原因" v-if="item.ywzt === '2'" :value="item.rejReason"/>
        </van-cell-group>
      </div>
      <div class="footer" slot="footer">
        <van-tag type="primary" mark align="float:right" v-if="item.ywzt === '0'">已办证待申请</van-tag>
        <van-tag type="warning" mark align="float:right" v-if="item.ywzt === 'X'">未办证无法申请</van-tag>
        <van-tag type="success" mark align="float:right" v-if="item.ywzt === '1'">已申请</van-tag>
        <van-tag type="primary" mark align="float:right" v-if="item.ywzt === '4'">补贴完成</van-tag>


        <van-button type="primary" size="small" v-if="item.ywzt === '0'&& item.fwxz === '1' && (item.ghyt === '10' || item.ghyt === '10106')" @click="taxSubsidiesApply(item.htId)">申请</van-button> <!-- 新建 住宅-->
        <van-button type="primary" size="small" v-if="item.ywzt === '0'&& (item.ghyt !== '10' && item.ghyt !== '10106'||item.fwxz === '2')" @click="taxQsSubsidiesApply(item.htId,item.fwxz,item.ghyt)">申请</van-button><!-- 新建商业 和 存量住宅商业-->
<!--        <van-button type="primary" size="small" v-if="item.ywzt === '2'&& item.fwxz === '1' && item.ghyt=== '10'" @click="taxSubsidiesApply(item.htId)">重新申请</van-button>-->
<!--        <van-button type="primary" size="small" v-if="item.ywzt === '2'&&  (item.ghyt === '123'||item.fwxz === '2')" @click="taxQsSubsidiesApply(item.htId,item.fwxz,item.ghyt)">重新申请</van-button>-->
        <van-button type="primary" size="small" v-if="item.ywzt === '1'||item.ywzt === '3'||item.ywzt === '4'" @click="taxSubsidiesApplyDetails(item.htId,item.fwxz,item.ghyt)">查看</van-button>
        <van-button type="primary" size="small" v-if="item.ywzt === 'X'" disabled>申请</van-button>
      </div>
    </van-card>
    <div class="div_no_recode" v-show="houseList == null || houseList.length === 0" style="">暂无符合条件的申请事项或您的补贴申请事项尚未开始，补贴发放问题请联系0476-5896639 技术支持请联系0476-5890055</div>
  </div>
</template>

<script>
  import Top from '@/views/components/Top'
  import {fetchMyFairHouses} from '@/api/houseResource/fair'
  import '@/styles/maintainFund.scss'
  import { Tag} from "vant";

  export default {
    name: "TaxSubsidies",
    filters: {
      ghytFilter(status) {
        // 10 和 10106 → 住宅，其他 → 非住宅
        const val = status.ghyt * 1;
        let ghytText = '';

        if (val === 10 || val === 10106) {
          ghytText = '住宅';
        } else {
          ghytText = '非住宅';
        }

        // 拼接房屋类型（新建商品房 / 存量房）
        const fwxzText = status.fwxz === '1' ? '新建商品房' : '存量房';
        return `${ghytText}(${fwxzText})`;
      }
    },
    data() {
      return {
        rightImg: require('@/assets/listRight.png'),
        houseList: []
      }
    },
    components: {
      BvTop: Top,
      // VanNoticeBar: NoticeBar,
      VanTag: Tag
    },
    mounted() {
      this.showLoading();
      fetchMyFairHouses().then(res => {
        this.houseList = res.data;
        this.$toast.clear();
      });
    },
    methods: {
      //全屏加载提示
      showLoading() {
        this.$toast.loading({
          // 持续展示 toast
          duration: 0,
          mask: true,
          message: '加载中...'
        });
      },
      taxSubsidiesApply(htId) {
        this.$router.push({path: '/personal/subsidies/taxSubsidiesApply', query: {label: '补贴申请', htId: htId}})
      },
      taxQsSubsidiesApply(htId,fwxz,ghyt) {
        this.$router.push({path: '/personal/subsidies/taxQsSubsidiesApply', query: {label: '补贴申请', htId: htId, fwxz: fwxz,ghyt:ghyt}})
      },
      taxSubsidiesApplyDetails(htId,fwxz,ghyt) {
        this.$router.push({path: '/personal/subsidies/taxSubsidiesApplyDetails', query: {label: '补贴申请详情', htId: htId, fwxz: fwxz, ghyt: ghyt}})
      }
    }
  }
</script>

<style lang="scss" scoped>
  .titleContent {
    border-left: solid 6px #2acba2;
    padding-left: 9px;
    display: inline;
  }
  .div_no_recode {
    margin-top: 40%;
    padding: 0 60px;
    color: red;
    font-size: 18px;
    line-height: 30px;
    text-indent:2em;
  }

</style>
